var render = function render(){var _vm=this,_c=_vm._self._c;return _c('App',[_c('Header',{attrs:{"imageLogo":"","userInfo":_vm.user,"helpMenu":_vm.helpMenu}}),_c('Main',{attrs:{"appVersion":_vm.version}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }